var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col_1 w215 member_left_menu"},_vm._l((_vm.menus),function(item){return _c('p',{key:item.id,class:item.iconClass},[_c('router-link',{attrs:{"to":item.path,"active-class":"focus"}},[_vm._v(_vm._s(item.name))])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0077cee4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/menu/menu.vue
// module id = null
// module chunks = 